import React from 'react';
//import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
//import { Avatar } from 'primereact/avatar';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
//import QuoteOfTheDay from '../components/QuoteOfTheDay'; // 👈 import

//import DashboardGrid from '../components/DashboardGrid';
import DashboardGridEditable from '../components/DashboardGridEditable';
import widgetRegistry from '../widgets/registry';

import { enablePushNotifications } from '../utils/enablePush';
import { sendTest } from '../services/pushService';

const Settings = () => {
  const {  logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const handleTestNotification = async () => {
  try {
    const result = await sendTest();
    console.log('Test notification result:', result);
  } catch (error) {
    console.error('Error sending test notification:', error);
  }
};

  const handleClearLayout = () => {
    localStorage.removeItem('layout');
    window.location.reload();
  };

  //const firstName = user?.first_name || '';
  //const lastName = user?.last_name || '';
  //const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  const layout = [];

  return (
    <div className="min-h-screen surface-ground p-4">
      <div className="flex justify-content-between align-items-center mb-4">
        <h2 className="m-0">Settings</h2>
          <Button
            label="Dashboard"
            icon="pi pi-home"
            severity="secondary"
            
            onClick={() => navigate('/dashboard')}
          />
          <Button
            label="Log Out"
            icon="pi pi-sign-out"
            severity="secondary"
            outlined
            onClick={handleLogout}
          />
      </div>
        <Button label="Send Test Notification" icon="pi pi-send" onClick={handleTestNotification} />
        <Button label="Enable Notifications" icon="pi pi-bell" onClick={() => enablePushNotifications().catch(console.error)} />
          <Button label="Clear Layout" icon="pi pi-trash" onClick={handleClearLayout} />
      <DashboardGridEditable fallbackLayout={layout} widgetRegistry={widgetRegistry} />
    </div>
  );
};

export default Settings;
